import React from 'react';
import PageTitle from "../PageTitle";
import Title from '../Title';
import Typography from "@material-ui/core/Typography";

//style
import style from "../help.module.scss";

//image
import Image01 from '../../../assets/help/topic/image01.png';


const Topic = () => {
    return (
        <article className={style.root}>
            <a id="1" className={style.anchor}/>
            <div className={style.box}>
                <PageTitle title={"未来トピック"}/>
                <Title title={"1. 未来トピック"}/>
                <Typography gutterBottom variant={"body1"}>
                    未来トピックは、WEB上に存在するデータを元に、HARVEST独自のAIが「未来のイベント」や「法改正」などに関連するワードをレコメンドする機能です。<br/>
                    未来の月毎に関連するワードから、関連する情報を検索することができます。
                </Typography>
                <div className={style.img}>
                    <img src={Image01}/>
                </div>
            </div>
        </article>
    );
};

export default Topic;
